import { html } from 'lit';
import { CircleEqual } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-circle-equal')
export class PdsIconCircleEqual extends PdsIcon {
  @state()
  icon = CircleEqual;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
